import { ModelBase } from '../../core/model/model-base';

export class DebtCollectionLog extends ModelBase {
  createdAt: Date;
  description: string;
}
